module.exports = __webpack_public_path__ + "static/media/(DH)_MG_4985-bijuterias.0b89b860.jpg";